module.exports = "/_next/static/images/37bdcc6e8d4b3826b8d9679d1eb14688-slide-2-large.png.webp";